import { Box, Container } from "@material-ui/core";

import { EstimateReturn } from "./EstimateReturn";
import { ElectricityBill } from "./ElectricityBill";
import { ConsumptionProduction } from "./ConsumptionProduction";
import { SolarReport } from "../../../../api/Quote/SolarReport";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

export const GraphsView = ({ solarReportData }: { solarReportData: SolarReport | null }) => {
  const { isMoreThanSm } = useBreakpoint();
  return (
    <Box>
      <Container maxWidth="lg">
        <Box maxWidth={"1169px"} mt={isMoreThanSm ? "79px" : "26px"} margin={"0 auto"}>
          <Box mt={0}>
            <EstimateReturn solarReportData={solarReportData} />
            <Box width={"100%"} height={"1px"} bgcolor={"rgba(151, 151, 151, 0.3)"} my={"60px"} />
            <ElectricityBill solarReportData={solarReportData} />
            <Box width={"100%"} height={"1px"} bgcolor={"rgba(151, 151, 151, 0.3)"} my={"60px"} />
            <ConsumptionProduction solarReportData={solarReportData} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
